//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AlgFlocktory from '@/modules/flocktory/AlgFlocktory'
import ApplicationFormSection from '~/components/common/section/ApplicationFormSection'

export default {
  name: 'SignupSection',
  components: {
    AlgFlocktory,
    ApplicationFormSection,
  },
  props: {
    crmTags: {
      type: String,
      required: true,
    },
    crmPipeline: {
      type: String,
      required: true,
    },
    crmStatus: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isThanksMessageActive: false,
      isErrorMessageActive: false,
      flocktoryEmail: '',
      flocktoryName: '',
    }
  },
  methods: {
    showThanksMessage(data) {
      this.flocktoryEmail = data.email
      this.flocktoryName = data.name
      this.isThanksMessageActive = true
    },
    hideThanksMessage() {
      this.isThanksMessageActive = false
    },
    showErrorMessage() {
      this.isErrorMessageActive = true
    },
    hideErrorMessage() {
      this.isErrorMessageActive = false
    },
  },
}
